import { useCoreStateContext } from 'spark-core-dx/contexts';

export const useSharedData = () => {
  const coreStateContext = useCoreStateContext();
   const options = {
            filters: [],
            datasets: coreStateContext.get("DashboardDatasets") ?? [],
            visualTypes: coreStateContext.get("VisualTypes") ?? [],
            visualOptionShells: coreStateContext.get("VisualOptionShells") ?? [],
            visualOptionShellsDraft: coreStateContext.get("VisualOptionShells_Draft") ?? []
          };   
  if(true)
    window.sharedData = options;
  return options;
};
